import React from 'react';
import {t} from '@lingui/core/macro';

import {PaymentSuccess, PaymentResultScreen} from 'features/payment';

const PaymentSuccessPage: React.FC = () => {
    return <PaymentResultScreen pageTitle={t`Успешная оплата`} Content={PaymentSuccess}/>;
};

export default PaymentSuccessPage;
